import TextField from '../components/FormConfigs/TextField';
import TimeWindow from '../components/FormConfigs/TimeWindow';
import SelectField from '../components/FormConfigs/SelectField';
import TypeQuantity from '../components/FormConfigs/TypeQuantity';
import CallbackNumber from '../components/FormConfigs/CallbackNumber';
// import Product from '../components/FormConfigs/Product';
import CheckboxList from '../components/FormConfigs/CheckboxList';
import DateTime from '../components/FormConfigs/DateTimeField';
// import TimeAbsolute from '../components/FormConfigs/TimeAbsolute'
import Calender from '../components/FormConfigs/Calendar';
import Radios from '../components/FormConfigs/RadiosField';
import DateField from '../components/FormConfigs/DateField';

// import Divider from '../components/FormConfigs/Divider';
import Textarea from '../components/FormConfigs/TextAreaField';
// import Integer from '../components/FormConfigs/Integer';
// import Time from '../components/FormConfigs/Time';
import TextLabel from '../components/FormConfigs/TextLabel';
import Missing from '../components/FormConfigs/Missing';

const formConfigMap = {
  textfield: TextField,
  time_window: TimeWindow,
  callback_number: CallbackNumber,
  type_quantity: TypeQuantity,
  // product: Product,
  checkbox_list: CheckboxList,
  datetime: DateTime,
  // time_absolute: TimeAbsolute,
  select: SelectField,
  calendar: Calender,
  radios: Radios,
  date: DateField,
  // divider: Divider,
  textarea: Textarea,
  // integer: Integer,
  // time: Time,
  textlabel: TextLabel,
  missing: Missing,
};

export default formConfigMap;



// WEBPACK FOOTER //
// ./src/config/formConfigMap.js